export const EMPTY_PROJECTS_TEXT = "You don't have any projects yet.";
